import { type CancellationProtection } from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";

function isWorkplaceCancellationProtectionEnabled(
  workplaceProtection: CancellationProtection | undefined
): boolean {
  return isDefined(workplaceProtection) && workplaceProtection.enabled;
}

export function isCancellationProtectionAvailableForWorkplace(params: {
  isFeatureEnabled: boolean;
  workplaceProtection: CancellationProtection | undefined;
}): boolean {
  return (
    params.isFeatureEnabled && isWorkplaceCancellationProtectionEnabled(params.workplaceProtection)
  );
}

export function isCancellationProtectionAvailableForBookableShift(params: {
  isFeatureEnabled: boolean;
  workplaceProtection: CancellationProtection | undefined;
  isPremiumApplied: boolean | undefined;
}): boolean {
  return (
    params.isFeatureEnabled &&
    isWorkplaceCancellationProtectionEnabled(params.workplaceProtection) &&
    isDefined(params.isPremiumApplied) &&
    params.isPremiumApplied
  );
}

export function isCancellationProtectionAvailableForBookedShift(params: {
  isFeatureEnabled: boolean;
  workplaceProtection: CancellationProtection | undefined;
  isShiftProtectionApplied: boolean;
}): boolean {
  return (
    params.isFeatureEnabled &&
    isWorkplaceCancellationProtectionEnabled(params.workplaceProtection) &&
    params.isShiftProtectionApplied
  );
}
